export const shortenModelPath = '/m/:slug';
export const shortenProductPath = '/p/:slug';